<template>
    <div>
        <SelectVisitorDialog v-model="isChangeBelongVisible" :curBelongIdIn="CoInfo.visitor_id" @confirm="belongConfirm"></SelectVisitorDialog>
        <div v-if="isSmallScreen">
            <CommonHeader></CommonHeader>
            <main class="p-4 bg-gray-50 min-h-screen mt-[70px]" id="app">
                <!-- 顶部选项卡 - 现在有3个标签 -->
                <div class="bg-white shadow-md rounded-b-lg mb-4">
                    <div class="flex flex-row overflow-x-auto no-scrollbar">
                        <button v-for="(tab, index) in ['咨询报告', '逐字稿', '个案笔记']"
                                :key="index"
                                @click="activeMobileTab = index"
                                class="flex-1 py-4 px-2 text-center font-medium text-sm whitespace-nowrap transition-all duration-200 ease-in-out"
                                :class="activeMobileTab === index ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50' : 'text-gray-500 hover:bg-gray-100'">
                            {{ tab }}
                        </button>
                    </div>
                </div>

                <!-- 共听结果面板 -->
                <div v-show="activeMobileTab === 0" class="pb-4">
                    <!-- 标题和导出按钮 -->
                    <div class="bg-white rounded-lg shadow-md p-4 mb-4">
                        <div class="flex flex-row justify-between items-center mb-3">
                            <h1 class="text-lg font-bold text-gray-800 truncate">{{CoInfo.CoTitle}}</h1>
                            <div @click="genPdfFile(1)"
                                 class="p-2 rounded-md text-white shadow-md active:scale-95 transition-transform text-xs"
                                 :style="{ backgroundColor: btnColor }">
                                导出文件
                            </div>
                        </div>

                        <!-- 元信息 - 更紧凑的布局 -->
                        <div class="space-y-2 text-xs">
                            <div class="flex flex-row items-center">
                                <div class="bg-blue-50 p-1.5 rounded-full mr-2">
                                    <i class="fas fa-clock text-blue-500 text-xs"></i>
                                </div>
                                <div class="flex flex-row">
                                    <span class="text-gray-500">来访时间:</span>
                                    <span class="font-medium text-gray-800 block">{{CoInfo.visitTime}}</span>
                                </div>
                            </div>
                            <div class="flex flex-row items-center">
                                <div class="bg-green-50 p-1.5 rounded-full mr-2">
                                    <i class="fas fa-upload text-green-500 text-xs"></i>
                                </div>
                                <div class="flex flex-row">
                                    <span class="text-gray-500">上传时间:</span>
                                    <span class="font-medium text-gray-800 block">{{CoInfo.uploadTime}}</span>
                                </div>
                            </div>
                            <div class="flex  flex-row items-center justify-between">
                                <div class="flex  flex-row items-center">
                                    <div class="bg-purple-50 p-1.5 rounded-full mr-2">
                                        <i class="fas fa-user text-purple-500 text-xs"></i>
                                    </div>
                                    <span class="text-gray-500">来访归属</span>
                                </div>
                                
                                <div class="flex flex-row items-center ">

                                    <button @click="belongHandle"
                                            class="flex flex-row items-center mt-1 px-2 py-1 rounded-full bg-gray-100 text-xs max-w-full active:bg-gray-200 transition-colors">
                                        <span class="rounded-full p-0.5 px-1.5 text-white" :style="{ backgroundColor: btnColor }">
                                            {{ CoInfo && CoInfo.visitorName ? CoInfo.visitorName.charAt(0) : '无' }}
                                        </span>
                                        <span class="mx-1 truncate">{{CoInfo && CoInfo.visitorName ? CoInfo.visitorName:"无归属"}}</span>
                                        <i class="fas fa-pencil-alt ml-auto text-xs"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- 关键词标签 - 更小的尺寸 -->
                        <!--<div class="flex flex-wrap gap-1.5 mt-3">
                            <span v-for="(item, index) in CoInfo.keyWords"
                                  :key="index"
                                  class="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs font-medium shadow-sm">
                                {{ item }}
                            </span>
                        </div>-->
                    </div>

                    <!-- 共听结果内容 -->
                    <div class="space-y-3">
                        <!-- 单一结果样式 -->
                        <div v-if="CoListeningRes && CoListeningRes.length === 1 && !CoListeningRes[0].title"
                             class="bg-white rounded-lg shadow-md p-4 transition-all duration-200 ease-in-out hover:shadow-lg">
                            <div class="flex items-center mb-2">
                                <div class="bg-blue-100 p-1.5 rounded-full mr-2">
                                    <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/conclusion_icon_summarize.svg" class="h-4 w-4">
                                </div>
                                <h5 class="font-bold text-gray-800 text-sm">综述</h5>
                            </div>
                            <div class="bg-gray-50 p-3 rounded-lg text-xs leading-5 border border-gray-100">
                                <p v-html="CoListeningRes[0].replace(/\n/g, '<br>')" class="text-gray-700"></p>
                            </div>
                        </div>

                        <!-- 多结果样式 -->
                        <div v-else
                             v-for="(subitem, index) in CoListeningRes"
                             :key="index"
                             class="bg-white rounded-lg shadow-md p-4 transition-all duration-200 ease-in-out hover:shadow-lg">
                            <div class="flex flex-row items-left mb-2 items-center">
                                <div class="bg-blue-100 p-1.5 rounded-full mr-2">
                                    <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/conclusion_icon_summarize.svg" class="h-4 w-4">
                                </div>
                                <h5 class="font-bold text-gray-800 text-sm">{{subitem.title}}</h5>
                            </div>
                            <div v-for="(inneritem, index2) in subitem.subitemlist" :key="index2" class="mb-3">
                                <div class="flex flex-row items-left mb-1">
                                    <div class="bg-pink-200 rounded-full h-1.5 w-1.5 mr-1.5"></div>
                                    <span class="font-medium text-xs text-gray-700">{{inneritem.itemTitle}}</span>
                                </div>
                                <div class="bg-gray-50 p-3 rounded-lg text-xs  text-left leading-5 border border-gray-100">
                                    <p v-html="inneritem.itemContent.replace(/\n/g, '<br>')" class="text-gray-700"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 逐字稿面板 -->
                <div v-show="activeMobileTab === 1" class="pb-4">
                    <div class="bg-white rounded-lg shadow-md p-4">
                        <div class="flex flex-row justify-between items-center mb-3">
                            <div class="flex flex-row items-center">
                                <!--<div class="bg-orange-100 p-2 rounded-full mr-2">
                                    <i class="fas fa-file-alt text-orange-500 text-sm"></i>
                                </div>-->
                                <i class="bg-orange-100 p-2 rounded-full mr-2 fas fa-file-alt text-orange-500 text-sm"></i>
                                <h2 class="text-lg font-bold text-gray-800">逐字稿</h2>
                            </div>
                            <div @click="genPdfFile(2)"
                                  class=" p-2 rounded-md text-white shadow-md active:scale-95 transition-transform text-xs"
                                    :style="{ backgroundColor: btnColor }">
                                导出文件
                            </div>
                        </div>

                        <div class="bg-gray-50 p-3 rounded-lg text-xs leading-5 border border-gray-100">
                            <div class="text-gray-700 overflow-auto text-left h-full px-10" v-html="fileContent">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 个案笔记面板 --> 
                <div v-show="activeMobileTab === 2" class="pb-4">
                    <div class="bg-white rounded-lg shadow-md p-4">
                        <!-- 标题和导出按钮 -->
                        <div class="flex flex-row justify-between items-center mb-3">
                            <div class="flex items-center flex-row">
                                <div class="bg-green-100 p-1.5 rounded-full mr-2">
                                    <i class="fas fa-pen-alt text-green-500 text-sm"></i>
                                </div>
                                <h2 class="text-lg font-bold text-gray-800">个案笔记</h2>
                            </div>
                            
                            <div @click="genPdfFile(0)"
                                    class=" p-2 rounded-md text-white shadow-md active:scale-95 transition-transform text-xs"
                                    :style="{ backgroundColor: btnColor }">
                                导出文件
                            </div>
                        </div>

                        <!-- 来访者信息卡片 - 更紧凑 -->
                        <div class="bg-gray-50 p-3 rounded-lg border border-gray-100 mb-3">
                            <div class="space-y-2">
                                <div class="flex items-left flex-row">
                                    <span class="text-xs font-medium text-gray-700 w-20">来访者姓名：</span>
                                    <span class="text-xs text-gray-800">{{CoInfo.visitorName || '未设置'}}</span>
                                </div>
                                <div class="flex items-center flex-row">
                                    <span class="text-xs font-medium text-gray-700 w-20">咨询主题：</span>
                                    <span class="text-xs text-gray-800">{{CoInfo.CoTitle || '未设置'}}</span>
                                </div>
                                <div class="flex items-center flex-row">
                                    <span class="text-xs font-medium text-gray-700 w-20">咨询时间：</span>
                                    <span class="text-xs text-gray-800">{{CoInfo.visitTime || '未设置'}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 编辑器工具栏 - 更紧凑 -->
                        <div class="mb-3 overflow-x-auto touch-pan-x bg-gray-50 p-2 rounded-lg border border-gray-100">
                            <div class="flex flex-row space-x-1.5 w-max">
                                <button v-for="format in [
                        {icon: 'bold', name: 'bold'},
                        {icon: 'underline', name: 'underline'},
                        {icon: 'italic', name: 'italic'},
                        {icon: 'strikethrough', name: 'strikeThrough'}
                    ]"
                                        :key="format.name"
                                        @click="formatText(format.name)"
                                        class="p-2 rounded-lg bg-white shadow-sm hover:bg-gray-100 text-xs transition-colors"
                                        :class="{'bg-blue-100 text-blue-600 shadow-inner':btnSta[format.name]}">
                                    <i :class="`fas fa-${format.icon}`"></i>
                                </button>
                                <div class="h-6 w-px bg-gray-300 mx-0.5 self-center"></div>
                                <button v-for="align in [
                        {icon: 'align-left', name: 'Left'},
                        {icon: 'align-center', name: 'Center'},
                        {icon: 'align-right', name: 'Right'}
                    ]"
                                        :key="align.name"
                                        @click="formatText('justify'+align.name)"
                                        class="p-2 rounded-lg bg-white shadow-sm hover:bg-gray-100 text-xs transition-colors"
                                        :class="{'bg-blue-100 text-blue-600 shadow-inner':btnSta['justify'+align.name]}">
                                    <i :class="`fas fa-${align.icon}`"></i>
                                </button>
                            </div>
                        </div>

                        <!-- 编辑器内容 -->
                        <div contenteditable="true"
                             class="border border-gray-300 rounded-lg p-3 bg-white min-h-[200px] flex-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 shadow-sm"
                             ref="editor"
                             @input="updateContent"
                             placeholder="请输入笔记内容..."></div>
                    </div>
                </div>
            </main>
            
        </div>
        <div v-else>
            <header class=" fixed sticky top-0 left-0 right-0 h-[60px] bg-gray-700 text-white flex z-10 items-center justify-between p-4 shadow">
                <div class="flex items-center">
                    <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2" />
                    <!--<span class="text-xl">识心智能</span>-->
                </div>
                <LoginModule @loginSucc="handleLogin" ref="loginModule" />
            </header>


            <main class="layout-page-content mt-2 " id="app">
                <div class="w-full h-full grid grid-cols-2">
                    <div class="h-full ">
                        <div class="flex flex-col h-full">
                            <div class="flex justify-between px-10 mb-5">
                                <div class="shadow-inner bg-gray-200 rounded p-1">
                                    <div class="" tabindex="-1" role="tablist">
                                        <div class="flex space-x-2" role="tablist">
                                            <button type="button" class="flex items-center px-6 py-2   text-gray-700 hover:bg-sky-200 rounded-lg"
                                                    role="tab"
                                                    :class="pageSelect === 0 ? 'bg-white': 'bg-gray-200'"
                                                    @click="setActiveTab(0)"
                                                    value="result">
                                                <i class="far fa-file-alt" />
                                                <span class="ml-2">咨询报告</span>
                                            </button>
                                            <button type="button" class="flex items-center px-6 py-2  text-gray-700  hover:bg-sky-200 rounded-lg" role="tab"
                                                    :class="pageSelect === 1 ? 'bg-white' : 'bg-gray-200'"
                                                    @click="setActiveTab(1)"
                                                    value="transcript">
                                                <i class="fas fa-newspaper"></i>
                                                <span class="ml-2">逐字稿</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" class="p-2 rounded-lg text-white" :style="{ backgroundColor: btnColor }" @click="genPdfFile(1)">
                                    <span class="px-4 text-xl" data-no-activator="">
                                        <i class="fas fa-file-download notranslate mr-2" aria-hidden="true"></i>
                                        导出PDF
                                    </span>
                                </button>
                            </div>
                            <div class="relative overflow-hidden">
                                <div class="flex transition-transform duration-300" :style="`transform: translateX(-${pageSelect * 100}%)` ">
                                    <div class="h-full w-full flex-shrink-0 overflow-y-auto scrollable" ref="leftContent">
                                        <div class="h-full w-full">
                                            <div class="ps h-full px-10 ps--active-y">
                                                <div class="flex flex-col gap-4 pr-2">
                                                    <div class="flex flex-col gap-5">
                                                        <div class="text-left text-3xl font-medium leading-9 text-gray-700">
                                                            {{CoInfo.CoTitle}}
                                                        </div>
                                                        <div class="text-left">
                                                            <div>
                                                                <span class="text-gray-500 text-lg font-normal">来访对话时间：</span>
                                                                <span class="text-lg font-bold text-gray-600">{{CoInfo.visitTime}}</span>
                                                            </div>
                                                            <div class="mt-2">
                                                                <span class="text-gray-500 text-lg font-normal">上传时间：</span>
                                                                <span class="text-lg font-bold text-gray-600">{{CoInfo.uploadTime}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <span class="text-gray-500 text-lg font-normal">归属来访：</span>
                                                            <div class="flex items-center" draggable="false" tabindex="0">
                                                                <div class="flex items-center gap-1 group rounded-full bg-gray-200 cursor-pointer group-hover:text-blue-200" @click="belongHandle">
                                                                    <div class="rounded-full p-2 px-3 text-white" :style="{ backgroundColor: btnColor }">{{ CoInfo && CoInfo.visitorName ? CoInfo.visitorName.charAt(0) : '无' }}</div>
                                                                    <div class="px-2">{{CoInfo && CoInfo.visitorName ? CoInfo.visitorName:"无归属"}}</div>
                                                                    <i class="fas fa-pencil-alt notranslate cursor-pointer mr-2" aria-hidden="true" style="font-size: 16px; height: 16px; width: 16px;"></i>
                                                                </div>
                                                                <span class="text-gray-800 p-2">更改文件归属来访</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex flex-wrap gap-2">
                                                            <span v-for="(item, index) in CoInfo.keyWords" :key="index" style="color: rgb(25, 75, 255);">
                                                                {{ item }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <hr class="v-divider v-theme--light" aria-orientation="horizontal" role="separator" />
                                                    <div v-if="CoListeningRes && CoListeningRes.length === 1  && !CoListeningRes[0].title" class="px-12px pb-3 py-16px gap-16px rounded-lg text-gray-600" :style="{ backgroundColor: getRandomColor() }">

                                                        <!--针对纯文本的方式。-->
                                                        <div class="px-4 mb-3 mt-3 flex relative items-center">
                                                            <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/conclusion_icon_summarize.svg" class="mr-2 h-5 w-5">
                                                            <h5 class="text-h5">综述</h5>
                                                        </div>

                                                        <div class="relative p-4 mx-1 mt-2 bg-white rounded-lg color-[#353E6D99] text-13px font-normal">
                                                            <div class="text-body-2 leading-5 text-left mr-2 ml-2">
                                                                <p v-html="CoListeningRes[0].replace(/\n/g, '<br>')"></p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div v-else v-for="(subitem, index)  in CoListeningRes" :key="index" class="px-12px pb-3 py-16px gap-16px rounded-lg text-gray-600" :style="{ backgroundColor: getRandomColor() }">
                                                        <div class="px-4 mb-3 mt-3 flex relative items-center">
                                                            <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/conclusion_icon_summarize.svg" class="mr-2 h-5 w-5">
                                                            <h5 class="text-h5">{{subitem.title}}</h5>
                                                        </div>
                                                        <div v-for="(inneritem, index2) in subitem.subitemlist" class="ml-2 px-2" :key="index2">
                                                            <div class="relative p-4 mx-1 mt-2 bg-white rounded-lg color-[#353E6D99] text-13px font-normal">
                                                                <div class="mb-1.5 flex items-center text-subtitle-1">
                                                                    <div class="mr-2 bg-[#ffe8f5] rounded-full h-2 w-2 overflow-hidden p-2"></div>
                                                                    {{inneritem.itemTitle}}
                                                                </div>
                                                                <div class="text-body-2 leading-5 text-left mr-2 ml-2">
                                                                    <p v-html="inneritem.itemContent.replace(/\n/g, '<br>')"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- 其他内容省略 -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-full flex-shrink-0   flex ">
                                        <div class="overflow-auto text-left h-full px-10" v-html="fileContent">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="h-full overflow-hidden">
                        <div class="flex flex-col h-full px-10 gap-8">
                            <div class="flex justify-between">
                                <div class="text-3xl font-medium text-gray-700">个案笔记</div>
                                <button type="button" class="p-2 rounded-lg text-white" :style="{ backgroundColor: btnColor }" @click="genPdfFile(0)">
                                    <span class="px-4 text-xl" data-no-activator="">
                                        <i class="fas fa-file-download notranslate mr-2" aria-hidden="true"></i>
                                        导出PDF
                                    </span>
                                </button>
                            </div>
                            <div class="rounded  h-full flex flex-col bg-white border border-solid border-gray-300 flex-1 overflow-hidden">
                                <div class="flex-1 overflow-auto mt-2">
                                    <div class="px-6 ">
                                        <div class="flex flex-col gap-2  ">
                                            <div class="flex gap-2 ">
                                                <button @click="formatText('bold')" class="v-btn p-2 rounded hover:bg-gray-100 "
                                                        :class="{'bg-blue-200 text-blue-600':btnSta.bold}">
                                                    <i class="fas fa-bold v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"> </i>
                                                </button>
                                                <button @click="formatText('underline')" class="v-btn p-2 rounded hover:bg-gray-100" :class="{'bg-blue-200 text-blue-600':btnSta.underline}">
                                                    <i class="fas fa-underline v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
                                                </button>
                                                <button @click="formatText('italic')" class="v-btn p-2 rounded hover:bg-gray-100 " :class="{'bg-blue-200 text-blue-600':btnSta.italic}">
                                                    <i class="fas fa-italic v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
                                                </button>
                                                <button @click="formatText('strikeThrough')" class="v-btn p-2 rounded hover:bg-gray-100 " :class="{'bg-blue-200 text-blue-600':btnSta.strikeThrough}">
                                                    <i class="fas fa-strikethrough v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
                                                </button>
                                                <button @click="formatText('justifyLeft')" class="v-btn p-2 rounded hover:bg-gray-100 " :class="{'bg-blue-200 text-blue-600':btnSta.justifyLeft}">
                                                    <i class="fas fa-align-left v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
                                                </button>
                                                <button @click="formatText('justifyCenter')" class="v-btn p-2 rounded hover:bg-gray-100 " :class="{'bg-blue-200 text-blue-600':btnSta.justifyCenter}">
                                                    <i class="fas fa-align-center v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
                                                </button>
                                                <button @click="formatText('justifyRight')" class="v-btn p-2 rounded hover:bg-gray-100 " :class="{'bg-blue-200 text-blue-600':btnSta.justifyRight}">
                                                    <i class="fas fa-align-right v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
                                                </button>
                                                <!--                <button @click="insertOrderedList" class="v-btn p-2 rounded ">
                                                <i class="i-tabler-list-numbers" aria-hidden="true"></i> 编号
                                            </button>
                                            <button @click="insertUnorderedList" class="v-btn p-2 rounded ">
                                                <i class="i-tabler-list" aria-hidden="true"></i> 项目符号
                                        </button>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div contenteditable="true"
                                         class="border p-4 bg-white  h-full"
                                         ref="editor"
                                         @input="updateContent"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { exportPDF } from '../../pdfExport.js'; 
    import hljs from 'highlight.js'
    import MarkdownIt from 'markdown-it'
    import LoginModule from './LoginModule.vue';

    import axios from 'axios';
    import SelectVisitorDialog from './subassembly/SelectVisitorDialog'; // 确保路径正确

    import CommonHeader from './subassembly/CommonHeader.vue';
    
    export default {
        components: {
            CommonHeader,
            LoginModule,
            SelectVisitorDialog,
        },
        name: "ConclusionEditor",
        data() {
            return {
                markdownIt: {},
                isChangeBelongVisible: false,
                activeMobileTab: 0, // 添加移动端标签切换状态变量
                pageSelect: 0,
                fileContent:"暂无",
                btnColor:'rgb(25, 75, 255)',
                btnSta:{
                    bold:false,
                    underline:false,
                    italic:false,
                    strikeThrough:false,
                    justifyLeft: false,
                    justifyRight:false,
                    justifyCenter:true,
                },
                CoInfo: {
                    visitorName:"",
                    visitor_id:"",
                    CoTitle: "基础版咨询记录个案概念化",
                    visitTime: "2025-01-01",
                    uploadTime: "2025-01-01",
                    keyWords: ["工作压力", "生活失衡", "意义感", "价值观",],
                    vinfo:null
                },
                CoListeningRes: [//大类级别
                    {
                        title: "个案概念化",
                        subitemlist: [
                            {
                                itemTitle: "基本信息：",
                                itemContent: "来访者Z，19岁，男性，某重点大学理工科二年级学生，首次咨询",
                            },
                            {
                                itemTitle: "呈现问题：",
                                itemContent: "•	近3个月持续出现入睡困难（日均睡眠<4小时）\n" +
                                    "•	注意力分散导致学业效率下降（本学期GPA较上季下降30%）\n" +
                                    '•	反复出现"我不可能成功"的侵入性思维',
                            },

                            {
                                itemTitle: "背景因素：",
                                itemContent: "•	父母均为高知人群，家庭对学业成就期待较高\n" +
                                    "•	半年前未入选国家级科创团队关键事件\n" +
                                    "•	近期存在社交退缩（日均手机使用时长12小时+）",
                            },


                            {
                                itemTitle: "心理机制假设：",
                                itemContent: "•	核心信念：自我价值=学业成就\n" +
                                    "•	维持因素：回避行为导致负向强化循环\n" +
                                    "•	保护因素：保持基本生活自理能力",
                            },
                        ]
                    },
                    {
                        title: "来访者主诉",
                        subitemlist: [
                            {
                                itemTitle: "原话记录：",
                                itemContent: "最近完全没法集中精神看书，每次打开教材就觉得心跳特别快...我知道这样下去会挂科，但越着急越学不进去。上周实验报告没写完，躲在卫生间哭了半小时...",
                            },
                        ]
                    },
                    {
                        title: "咨询师咨询过程总结：",
                        subitemlist: [
                            {
                                itemTitle: "1. 咨询目标",
                                itemContent: "近期目标（1-3次）：\n" +
                                    "•\t建立安全情绪表达机制\n" +
                                    "•\t睡眠质量改善至日均6小时\n" +
                                    "•\t制定阶梯式学习计划\n" + "远期目标：\n" +
                                    "•\t构建多元自我评价体系\n" +
                                    "•\t提升压力情境下的情绪调节能力\n",
                            },
                            {
                                itemTitle: "2. 咨询方法",
                                itemContent: "•\t认知解离技术（针对自我批判性思维）\n" +
                                    "•\t行为激活练习（建立日常作息锚点）\n" +
                                    "•\t焦点解决短期治疗（挖掘例外资源）\n",
                            },
                            {
                                itemTitle: "3. 咨询过程与步骤",
                                itemContent: "阶段进程：<\b>\n" +
                                    "1.\t初始阶段（0-15min）\n" +
                                    "￮\t建立咨询契约\n" +
                                    "￮\t使用情绪温度计技术量化焦虑程度（当前自评7/10分）\n" +
                                    "2.\t工作阶段（15-40min）\n" +
                                    "￮\t探索\"失败认知\"的形成路径\n" +
                                    "￮\t共同构建\"例外时刻\"时间轴（发现大一时成功应对考试经历）\n" +
                                    "￮\t制定\"20分钟专注-5分钟放松\"的行为实验\n" +
                                    "3.\t结束阶段（40-50min）\n" +
                                    "￮\t呼吸放松训练教学\n" +
                                    "￮\t商定家庭作业：记录每日3个微小成就\n",
                            },
                        ]
                    },

                    {
                        title: "AI评估与风险",
                        subitemlist: [
                            {
                                itemTitle: "1.诊断印象：",
                                itemContent: "初步评估为适应性障碍伴焦虑症状（依据ICD-11 6B43），需排除抑郁症可能，建议结合SDS量表评估。",
                            },
                            {
                                itemTitle: "2.诊断依据：",
                                itemContent: "a.\t适应性障碍诊断（ICD-11 6B43）\n" +
                                    "▪\t依据世界卫生组织《国际疾病分类第十一版》：\n" +
                                    "✓ 压力源存在（未入选科创团队）\n" +
                                    "✓ 症状出现在压力事件3个月内\n" +
                                    "✓ 伴随明显社会功能损害（GPA下降30%）\n" +
                                    "✓ 不符合其他精神障碍诊断标准\n" +
                                    "b.\t抑郁症排查建议\n" +
                                    "▪\t参照《DSM-5》重性抑郁障碍诊断标准：\n" +
                                    "✓ 需确认症状持续是否达2周\n" +
                                    "✓ 重点评估：情绪低落频次、快感缺失程度、躯体症状",
                            },
                            {
                                itemTitle: "3.进展评估：",
                                itemContent: "•\t咨访关系建立程度：★★★☆☆\n" +
                                    "•\t目标达成进度：15%",
                            },
                            {
                                itemTitle: "4.风险预警：",
                                itemContent: "•\t当前自杀风险评估：1级（无直接风险，存在被动死亡念头）\n" +
                                    "•\t需关注昼夜节律紊乱导致的躯体化反应\n",
                            },
                        ]
                    },

                    {
                        title: "AI对咨询的反思与建议",
                        subitemlist: [
                            {
                                itemTitle: "1.反思：",
                                itemContent: "本次咨询在情绪聚焦方面取得突破，但对学业压力源的系统分析尚不充分。建议下次咨询引入时间饼图技术，并注意来访者谈及家庭时的躯体防御反应。\n" +
                                    "实例：学业压力源系统分析不足的具体表现\n" +
                                    "情境再现：\n" +
                                    "咨询中来访者陈述：\"每天从实验室回宿舍就开始刷题到凌晨，但越学效率越低，上周模电作业竟然错了基础题...\"\n" +
                                    "原处理方式：\n" +
                                    "a.\t聚焦情绪反应：引导来访者描述\"效率低下时的身体感受\"\n" +
                                    "b.\t认知重构：挑战\"必须熬夜学习\"的不合理信念\n" +
                                    "不足分析：\n" +
                                    "c.\t压力源时空分布盲区\n" +
                                    "▪\t未探查压力传导路径：实验室环境（设备噪音/竞争氛围）→ 宿舍学习状态\n" +
                                    "▪\t遗漏关键时段：忽略\"实验课后2小时\"的高反刍思维期\n" +
                                    "d.\t压力层级未分化\n" +
                                    "▪\t将学业压力视为单一维度，未区分：\n" +
                                    "✓ 课程压力（模电作业难度）\n" +
                                    "✓ 竞赛压力（科创团队落选阴影）\n" +
                                    "✓ 自我施压（每日学习时长≥14小时）\n" +
                                    "改进证据：\n" +
                                    "使用时间饼图技术后，发现：\n" +
                                    "\t72%的高压时段集中在17:00-21:00（实验课后续时段）\n",
                            },
                            {
                                itemTitle: "2.后续咨询方向建议：",
                                itemContent: "•\t布置正念饮食练习（建立身心连接）\n" +
                                    "•\t建议进行HAMD-17量表筛查\n" +
                                    "•\t对来访者压力源进行持续解构\n" +
                                    "•\t引导来访者来访者进行认知重构，增强自我关怀",
                            },
                        ]
                    },
                ],
            };
        },
        methods: {
            async genPdfFile(isleft) {
                this.errorMessage = ''; // 清空之前的错误信息
                try {
                    var content;
                    if(isleft){
                        content = this.$refs.leftContent;
                    }else{
                        content = this.$refs.editor;
                    }
                    await exportPDF(content, 'export.pdf'); // 调用导出函数
                    //await exportPDF(this.fileContent, 'export.pdf');//TODO 输出名称需要调整
                    this.$message.success('pdf导出成功！');
                } catch (error) {
                    this.$message.error('pdf导出失败: ' + error.message);
                }
            },
            formatText(command) {
                if (command == "justifyLeft" || command == "justifyRight" || command == "justifyCenter") {
                    this.btnSta["justifyLeft"] = false;
                    this.btnSta["justifyRight"] = false;
                    this.btnSta["justifyCenter"] = false;
                    this.btnSta[command] = !this.btnSta[command];
                    
                } else {
                    this.btnSta[command] = !this.btnSta[command];
                }
                document.execCommand(command, this.btnSta[command], null);
                this.updateContent(); // 更新内容
                 this.$refs.editor.focus();
            },
            insertOrderedList() {
                document.execCommand('insertOrderedList');
                this.updateContent(); // 更新内容
            },
            insertUnorderedList() {
                document.execCommand('insertUnorderedList');
                this.updateContent(); // 更新内容
            },
            updateContent() {
                this.content = this.$refs.editor.innerHTML;
            },
        //连续点2个biu 后会导致判断出错。 TODO
            setActiveTab(tab) {
                if (this.pageSelect == tab) {
                    return;
                }
                this.pageSelect = tab;
            },
            getRandomColor() {
                // 生成较淡的随机颜色
                const r = Math.floor(Math.random() * 120); // 红色值
                const g = Math.floor(Math.random() * 120); // 绿色值
                const b = Math.floor(Math.random() * 120); // 蓝色值

                // 计算平均值以生成浅色
                const lightColor = `rgba(${Math.floor(r + 128)}, ${Math.floor(g + 128)}, ${Math.floor(b + 128)}, 0.4)`;
                return lightColor;
            },
            belongHandle() {
                this.isChangeBelongVisible = true;
            },
            handleLogin() { },
            async initParse() {
                const token = localStorage.getItem('token');
                if (!token) {
                    return;
                }
                var params = localStorage.getItem("router");
                if (!params) {
                    return;
                }
                var paramsObj = JSON.parse(atob(params));
               //listen
                console.log("taskid:" + paramsObj.id);
                const url = '/api/listen/detail';
                const data = {
                    taskid: paramsObj.id,
                };
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };

                try {
                    const response = await axios.post(url, data, { headers });
                    if (response.status === 200) {
                        console.log(response.data);
                        if (response.data.info.analysis) {
                            try {
                                this.CoListeningRes = JSON.parse(response.data.info.analysis);
                            } catch (error){
                                console.log("analysis parse error");
                            }
                        }
                        if (response.data.info.orgfile) {
                            try {
                                this.fileContent = this.markdownIt.render(response.data.info.orgfile);
                            } catch (error) {
                                console.log("response.data.info.orgfile");
                                console.log(response.data.info.orgfile);
                                console.log(error);
                                this.fileContent = response.data.info.orgfile;
                            }
                        }

                        //this.CoListeningRes = this.CoListeningRes.replace(/\n/g, '<br>')
                        console.log(this.CoListeningRes);
                        if (response.data.info.created_at) {
                            this.CoInfo.uploadTime = response.data.info.created_at.slice(0, 19);
                        }
                        if (response.data.info.visitDate) {
                            const date = new Date(response.data.info.visitDate);
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            const hours = String(date.getHours()).padStart(2, '0');
                            const minutes = String(date.getMinutes()).padStart(2, '0');
                            const seconds = String(date.getSeconds()).padStart(2, '0');
                            this.CoInfo.visitTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                        }
                        
                        this.CoInfo.CoTitle = response.data.info.file_name;
                        this.CoInfo.visitorName = response.data.info.visitorName;
                        this.CoInfo.visitor_id = response.data.info.visitor_id;
                    } else {
                        console.error('请求失败，状态码:', response.status);    
                    }
                } catch (error) {                        
                    console.error('get error:', error.message);
                }
            },
            async belongConfirm(choiceObj) {
                var params = localStorage.getItem("router");
                if (!params) {
                    this.$message.error("关键信息丢失，请重新登录");
                    return;
                }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error("登录失效，请重新登录");
                    return;
                }
                var paramsObj = JSON.parse(atob(params));
                if (paramsObj.type == "test") {
                    this.$message.error("关键信息错误，请重新登录");
                    return;
                } else {//listen
                    console.log("taskid:" + paramsObj.id);

                    const url = '/api/listen/belong';
                    const data = {
                        taskid: paramsObj.id,
                        newVid: choiceObj.id,
                    };
                    const headers = {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    };

                    try {
                        const response = await axios.post(url, data, { headers });
                        if (response.status === 200) {
                            console.log(response.data);
                            this.$message.success("归属修改成功");
                            this.CoInfo.visitor_id = String(choiceObj.id);
                            this.CoInfo.visitorName = choiceObj.vname;                           
                        } else {
                            console.error('请求失败，状态码:', response.status);
                        }
                    } catch (error) {
                        console.error('get error:', error.message);
                    }
                }
            },
        },
        created() {
            this.initParse();
        },
        mounted() {
            this.markdownIt = MarkdownIt({
                html: true,
                linkify: true,
                highlight: function (str, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(str, { language: lang }).value
                        } catch (__) {
                            console.log("1");
                        }
                    }
                    return '' // use external default escaping
                }
            })
        }
    };
</script>

<style >
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

</style>